import React from "react";
import styled from "styled-components";
import { resourceLinks } from "./data/resourceLinks";

const ResourcesContainer = styled.div`
  margin-inline: 5%;
`

const StyledMessage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 2rem;

  @media screen and (max-width: 1188px) {
    margin: auto;
  }
`;

const StyledLeftCopy = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  @media screen and (max-width: 1188px) {
    padding: 0;
    margin-bottom: 2rem;
  }
`;

const StyledRightImageArea = styled.div`
  @media screen and (max-width: 1188px) {
    text-align: center;
    width: 100%;
  }
`;

const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
  max-height: 700px;
  border-radius: 10px;
  transition: all 0.3s ease;
`;


const StyledHeading = styled.div`
  text-align: center;
  padding: 4rem 0 2rem 0;
`;


const StyledTd = styled.td`
  padding: 1rem;
`;

const Resources = () => {
  return (
    <ResourcesContainer>
      <StyledHeading>
        <h2>Some helpful links to guide your path</h2>
      </StyledHeading>
      <StyledMessage>
        <StyledLeftCopy>
          <table>
            {resourceLinks.map((link) => (
              <tr>
                <StyledTd>
                  <a href={link.url} target="blank">
                    {link.label}
                  </a>
                </StyledTd>
              </tr>
            ))}
          </table>
        </StyledLeftCopy>
        <StyledRightImageArea>
          <StyledImage
            src="https://d3lar93zsohcaj.cloudfront.net/lotus_frog.jpg"
            alt="Pink lotus and frog"
          />
        </StyledRightImageArea>
      </StyledMessage>
    </ResourcesContainer>
  );
};

export default Resources;
